import React from 'react';
import { companyInfo } from '../mock';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative bg-[#0f0d0b] text-white pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={companyInfo.logoUrl} alt="Cherry Stone" className="w-10 h-11 object-contain" />
              <div>
                <div className="font-serif text-xl tracking-wide">CHERRY STONE</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/60">Pte Ltd · Singapore</div>
              </div>
            </div>
            <p className="mt-6 text-white/70 max-w-md text-[15px] leading-relaxed">
              Supplying, fabricating and installing the world’s finest natural and
              engineered stones — for a Singapore that lives beautifully.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.28em] uppercase text-[#B8935A] mb-5">Explore</div>
            <ul className="space-y-3 text-white/80">
              <li><a className="hover:text-[#F1EBE1] transition-colors" href="#about">About</a></li>
              <li><a className="hover:text-[#F1EBE1] transition-colors" href="#services">Services</a></li>
              <li><a className="hover:text-[#F1EBE1] transition-colors" href="#stones">Stones</a></li>
              <li><a className="hover:text-[#F1EBE1] transition-colors" href="#projects">Projects</a></li>
              <li><a className="hover:text-[#F1EBE1] transition-colors" href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.28em] uppercase text-[#B8935A] mb-5">Reach us</div>
            <ul className="space-y-4 text-white/80 text-sm">
              <li className="flex items-start gap-3"><MapPin size={15} className="mt-1 text-[#B8935A]" />{companyInfo.address}</li>
              <li className="flex items-start gap-3"><Phone size={15} className="mt-1 text-[#B8935A]" />{companyInfo.phone1} · {companyInfo.phone2}</li>
              <li className="flex items-start gap-3"><Mail size={15} className="mt-1 text-[#B8935A]" />{companyInfo.email}</li>
              <li>
                <a href={companyInfo.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-2 text-white/80 hover:text-white transition-colors">
                  <Instagram size={15} className="text-[#B8935A]" /> @cherrystonesg
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Cherry Stone Pte Ltd. All rights reserved.</div>
          <div className="tracking-[0.28em] uppercase text-[10px]">Crafted in Singapore</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
